import {
  LIST_ONBOARDING_REQUESTS,
  STORE_ONBOARDING_REQUESTS,
  UPDATE_ONBOARDING_REQUEST,
  ACTIVATE_ONBOARDING_REQUEST,
  SEND_ONBOARDING_WELCOME,
} from '../../constants/onboarding';

export const listOnboardingRequests = (data) => ({
  type: LIST_ONBOARDING_REQUESTS,
  data,
});

export const storeOnboardingRequests = (requests) => ({
  type: STORE_ONBOARDING_REQUESTS,
  requests,
});

export const updateOnboardingRequest = (data, callback) => ({
  type: UPDATE_ONBOARDING_REQUEST,
  data,
  callback,
});

export const activateOnboardingRequest = (data, callback) => ({
  type: ACTIVATE_ONBOARDING_REQUEST,
  data,
  callback,
});

export const sendOnboardingWelcome = (data, callback) => ({
  type: SEND_ONBOARDING_WELCOME,
  data,
  callback,
});
